import Vue from 'vue';
import store from './store.js';
import {
    LiveSearch,
    CollectionComponent,
    ContinuousCollectionComponent,
    SyncsWithUrl,
    ResetsPage,
} from 'clockvine-vue';

const app = new Vue({
    el: 'main',
    store,

    data: {
        params: {
            page: 1,
            search: '',
            country: null,
            state: null,
        },
    },

    computed: {
        nextPage() {
            const urlParams = new URLSearchParams(location.search);
            urlParams.set('page', this.params.page + 1);
            return '?' + urlParams.toString();
        },

        isUsOrCanada() {
            return ['united-states', 'canada'].includes(this.params.country);
        },

        dealerParams() {
            if (this.isUsOrCanada && this.params.state) {
                return this.params;
            } else if (this.params.country && !this.isUsOrCanada) {
                return this.params;
            } else {
                return {};
            }
        },
    },

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
            orderBy: 'title asc',
        }),
        new ResetsPage(),
    ],

    components: {
        dealers: ContinuousCollectionComponent.for('dealers'),
        dealerCountries: CollectionComponent.for('dealerCountries'),
        dealerStates: CollectionComponent.for('dealerStates'),
        search: LiveSearch,
    },
});
